import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ItemsList from "./components/ItemsList";
import ItemDetail from "./components/ItemDetail";
import LiveScoreboard from "./components/LiveScoreboard";
import TermsAndConditions from "./pages/TermsAndConditions";
import QRCodes from "./pages/QRCodes";
import Admin from "./components/Admin";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ItemsList />} />
        <Route path="/item/:slug" element={<ItemDetail />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/live" element={<LiveScoreboard />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/qrcodes" element={<QRCodes />} />
      </Routes>
    </Router>
  );
}

export default App;
